module.exports = __webpack_public_path__ + "images/books_emoji.png";